/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamCreateRequestSchema = z.object({
  description: z.string().nullish(),
  instanceId: z.string().nullish(),
  loopId: z.int().nullish(),
  name: z.string().min(1),
  sourceId: z.string().nullish(),
});
